import { setStoredSessionToken } from './apiClient';

export function checkoutIntentFromSearch(search) {
  const params = new URLSearchParams(search);
  const plan = params.get('plan');
  const interval = params.get('interval') || 'monthly';
  const currency = params.get('currency') || 'gbp';
  if (!['individual', 'practice'].includes(plan) || !['monthly', 'yearly'].includes(interval) || !['gbp', 'eur'].includes(currency)) return undefined;
  return { plan, interval, currency };
}

export function continuationSearch(search = window.location.search) {
  const source = new URLSearchParams(search);
  const params = new URLSearchParams();
  const language = source.get('lang');
  if (['en', 'it'].includes(language)) params.set('lang', language);
  const invite = source.get('invite_token');
  if (invite && invite.length <= 4096) params.set('invite_token', invite);
  const intent = checkoutIntentFromSearch(search);
  if (intent) Object.entries(intent).forEach(([key, value]) => params.set(key, value));
  return params.toString() ? `?${params}` : '';
}
export const authScreenUrl = path => `${path}${continuationSearch()}`;

// Scrub session handoff credentials before rendering. Purpose-bound email
// tokens belong to their dedicated screens and must never become sessions.
export function extractLegacySessionToken() {
  const url = new URL(window.location.href);
  const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
  const token = hash.get('session_token') || url.searchParams.get('session_token') || '';
  hash.delete('session_token');
  url.searchParams.delete('session_token');
  if (url.pathname === '/' || url.pathname === '/auth-callback') url.searchParams.delete('token');
  url.hash = hash.toString();
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  return { token, url };
}
export function consumeSessionToken() {
  const { token, url } = extractLegacySessionToken();
  if (token) setStoredSessionToken(token);
  return url;
}

export function scrubEmailToken() {
  const url = new URL(window.location.href);
  url.searchParams.delete('token');
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}`);
}

// Server continuations are constrained again at the browser boundary. OAuth
// destinations are accepted only by the dedicated Google start action.
export function safeAppContinuation(value) {
  const fallback = `/${continuationSearch()}`;
  if (!value) return fallback;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || !['/', '/auth-callback'].includes(url.pathname)) return fallback;
    return `/${continuationSearch(url.search)}`;
  } catch (_) { return fallback; }
}
export function googleAuthorizationUrl(value) {
  const url = new URL(value);
  if (url.protocol !== 'https:' || url.hostname !== 'accounts.google.com') throw new Error('INVALID_REDIRECT');
  return url.toString();
}
